var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-case-declarations */
import { ArrowUpward } from '@mui/icons-material';
import { Box, Checkbox, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setTransportItem } from 'app/actions/issue';
import { addTransportCheckedId, deleteTransportCheckedItem, setTransportCheckedItem, setTransportMarkedCheckedItem, setTransportSelectedItem, setTransportSortSelectedItem, } from 'app/actions/map';
import { Autosizer, Protect, Scrollbar } from 'app/components';
import { TransportCircleIcon, TransportConditionSignalOffIcon, TransportFuelIcon, TransportParkingIcon, TransportSensorIcon, TransportSquareIcon, TransportTriangleIcon, } from 'app/icons';
import { MapTransportConditionIconsList } from 'app/pages/Map';
import { useInterval, useLocalStorage, useSingleAndDoubleClick } from 'app/services';
import { filterAndSortTransportItems } from 'app/utils/mapTransportList';
import React, { createContext, createRef, forwardRef, useEffect, useMemo, useRef, useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
import { translitToRus } from '../../utils';
const mapTransportIcons = {
    TransportFuelIcon,
    TransportParkingIcon,
    TransportSensorIcon,
    TransportConditionSignalOffIcon,
};
const MapFilterTransportListContext = createContext(null);
const MapTransportIcon = ({ name }) => {
    if (!name) {
        return React.createElement(React.Fragment, null);
    }
    const Component = mapTransportIcons[name];
    if (Component) {
        return React.createElement(Component, null);
    }
    return React.createElement(React.Fragment, null);
};
const MapFilterTransportList = () => {
    const dispatch = useDispatch();
    const isResizingColumn = useRef(null);
    const transportCheckedItems = useSelector((state) => state.map.transportFilterCheckedType === 'filter' ? state.map.transportProcessingCheckedItems : state.map.transportCheckedItems);
    const { ref: mapRef, transportItems, transportFilterCheckedItems, transportSortSelectedItem, transportSelectedItem, transportColumnCheckedItems, transportSearchValue, transportCheckedItems: transportCheckedItemsAll, transportProcessingCheckedItems, transportFilterCheckedType, transportMarkedCheckedItems, isHistoryOpen, } = useSelector((state) => state.map);
    const handleItemClickEvent = (value) => {
        var _a, _b, _c, _d, _e;
        dispatch(setTransportSelectedItem(value));
        dispatch(setTransportItem(value));
        const lastData = ((_a = value.conditions) === null || _a === void 0 ? void 0 : _a.length) ? value.conditions[value.conditions.length - 1].data : null;
        if (lastData && lastData.geodata !== 'ERR' && lastData.lat != null && lastData.lon != null) {
            (_c = (_b = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _b === void 0 ? void 0 : _b.handleClosePopup) === null || _c === void 0 ? void 0 : _c.call(_b);
            (_e = (_d = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _d === void 0 ? void 0 : _d.handleFlyTo) === null || _e === void 0 ? void 0 : _e.call(_d, [lastData.lat, lastData.lon], null);
        }
    };
    const handleItemDoubleClickEvent = (value) => {
        var _a, _b, _c, _d, _e;
        if (transportCheckedItems.indexOf(value.id) !== -1) {
            dispatch(addTransportCheckedId(value.id));
        }
        const lastData = ((_a = value.conditions) === null || _a === void 0 ? void 0 : _a.length) ? value.conditions[value.conditions.length - 1].data : null;
        if (lastData && lastData.geodata !== 'ERR' && lastData.lat != null && lastData.lon != null) {
            (_c = (_b = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _b === void 0 ? void 0 : _b.handleClosePopup) === null || _c === void 0 ? void 0 : _c.call(_b);
            (_e = (_d = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _d === void 0 ? void 0 : _d.handleFlyTo) === null || _e === void 0 ? void 0 : _e.call(_d, [lastData.lat, lastData.lon], config.mapMaxZoom);
        }
    };
    const { handleItemClick, handleItemDoubleClick } = useSingleAndDoubleClick({
        onClick: (v) => handleItemClickEvent(v),
        onDoubleClick: (v) => handleItemDoubleClickEvent(v),
    });
    const [, setTransportCheckedStorageItems] = useLocalStorage('transportCheckedItems', []);
    const [, setTransportMarkedCheckedStorageItems] = useLocalStorage('transportMarkedCheckedItems', []);
    const [, setTransportProcessingCheckedStorageItems] = useLocalStorage('transportProcessingCheckedItems', []);
    const [, setTransportSortCheckedStorageItems] = useLocalStorage('transportSortSelectedItem', {});
    const [transportColumnsWidth, setTransportColumnsWidth] = useLocalStorage('transportColumnsWidth', {});
    const [datetimeInterval, setDatetimeInterval] = useState(moment());
    const listRef = useRef(null);
    const columns = useMemo(() => config.mapTransportColumns
        .filter((column) => transportColumnCheckedItems.indexOf(column.name) !== -1)
        .map((column) => (Object.assign(Object.assign({}, column), { width: transportColumnsWidth[column.name]
            ? transportColumnsWidth[column.name]
            : column.width
                ? column.width
                : column.minWidth }))), [transportColumnsWidth, transportColumnCheckedItems]);
    const columnsWatch = useRef(columns);
    const columnsRefs = useRef(config.mapTransportColumns.reduce((acc, column) => {
        acc[column.name] = createRef();
        return acc;
    }, {}));
    const sortItems = useMemo(() => {
        let items = filterAndSortTransportItems(transportItems, transportFilterCheckedItems, transportSortSelectedItem, datetimeInterval);
        if (isHistoryOpen) {
            items = items.filter((item) => transportCheckedItems.indexOf(item.id) !== -1);
        }
        return items;
    }, [
        transportItems,
        transportFilterCheckedItems,
        transportSortSelectedItem,
        datetimeInterval,
        isHistoryOpen,
        isHistoryOpen ? transportCheckedItems : null,
    ]);
    const searchItems = useMemo(() => {
        if (transportSearchValue.length) {
            return sortItems.filter((item) => {
                if (transportSortSelectedItem.name === 'geofence') {
                    return (translitToRus(item.name).indexOf(translitToRus(transportSearchValue)) !== -1 ||
                        translitToRus(item.geofence_name || '').indexOf(translitToRus(transportSearchValue)) !== -1);
                }
                return translitToRus(item.name).indexOf(translitToRus(transportSearchValue)) !== -1;
            });
        }
        return sortItems;
    }, [sortItems, transportSearchValue, transportSortSelectedItem.name]);
    const handleSortClick = (value) => dispatch(setTransportSortSelectedItem(value));
    const handleCheckboxClick = (value) => (event) => {
        var _a, _b, _c, _d, _e;
        event.preventDefault();
        event.stopPropagation();
        const notChecked = transportCheckedItems.indexOf(value.id) === -1;
        if (notChecked) {
            dispatch(addTransportCheckedId(value.id));
        }
        else {
            dispatch(deleteTransportCheckedItem(value.id));
        }
        const lastData = ((_a = value.conditions) === null || _a === void 0 ? void 0 : _a.length) ? value.conditions[value.conditions.length - 1].data : null;
        if (notChecked && lastData && lastData.geodata !== 'ERR' && lastData.lat != null && lastData.lon != null) {
            (_c = (_b = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _b === void 0 ? void 0 : _b.handleClosePopup) === null || _c === void 0 ? void 0 : _c.call(_b);
            (_e = (_d = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _d === void 0 ? void 0 : _d.handleFlyTo) === null || _e === void 0 ? void 0 : _e.call(_d, [lastData.lat, lastData.lon], null);
        }
    };
    const handleCheckboxHeadClick = (e) => {
        const newIds = searchItems.map((item) => item.id);
        const target = e.target;
        batch(() => {
            if (target.checked) {
                const checkedItems = Array.from(new Set([...transportCheckedItems, ...newIds]));
                dispatch(setTransportCheckedItem(checkedItems));
                dispatch(setTransportMarkedCheckedItem(transportMarkedCheckedItems.filter((item) => checkedItems.indexOf(item) === -1)));
            }
            else {
                const showItems = new Set(newIds);
                const checkedItems = transportCheckedItems.filter((id) => !showItems.has(id));
                const markedItems = Array.from(new Set([...transportMarkedCheckedItems, ...newIds]));
                dispatch(setTransportCheckedItem(checkedItems));
                dispatch(setTransportMarkedCheckedItem(markedItems));
            }
        });
    };
    const adjustWidthColumn = (name, width) => {
        var _a, _b;
        const columnIndex = columnsWatch.current.findIndex((column) => column.name === name);
        const column = columnsWatch.current[columnIndex];
        const newWidth = width > (column.maxWidth || width) ? column.maxWidth || width : width < (column.minWidth || 0) ? column.minWidth || width : width;
        const current = columnsRefs.current[name].current;
        const ul = (_b = (_a = current === null || current === void 0 ? void 0 : current.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement;
        if (current === null || current === void 0 ? void 0 : current.parentElement) {
            current.parentElement.style.width = newWidth + 'px';
            current.parentElement.style.minWidth = newWidth + 'px';
        }
        if (ul === null || ul === void 0 ? void 0 : ul.children) {
            for (let i = 0; i < ul.children.length; i++) {
                const cell = ul.children[i].children[columnIndex];
                if (cell) {
                    cell.style.width = newWidth + 'px';
                    cell.style.minWidth = newWidth + 'px';
                }
            }
        }
    };
    const handleOnMouseMove = (e) => {
        var _a, _b, _c;
        if (isResizingColumn.current) {
            const parentLeft = (_c = (_b = (_a = columnsRefs.current[isResizingColumn.current]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().left;
            if (parentLeft != null) {
                const newWidth = e.clientX - parentLeft;
                adjustWidthColumn(isResizingColumn.current, newWidth);
            }
        }
    };
    const handleOnMouseUp = () => {
        isResizingColumn.current = null;
        const columnsInfo = {};
        columns.forEach((column) => {
            var _a, _b;
            const parentElement = (_b = (_a = columnsRefs.current[column.name]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.parentElement;
            columnsInfo[column.name] = parentElement ? parseInt(parentElement.style.width.slice(0, -2), 10) : column.width || column.minWidth || 0;
        });
        setTransportColumnsWidth(columnsInfo);
    };
    const handleResizeColumn = (column, e) => {
        e.preventDefault();
        isResizingColumn.current = column.name;
    };
    const handleColumnRef = (column, el) => {
        if (el && !columnsRefs.current[column.name].current) {
            columnsRefs.current[column.name].current = el;
        }
    };
    useInterval(() => {
        if (moment().seconds() === 0) {
            setDatetimeInterval(moment());
        }
    }, 1000);
    useEffect(() => {
        document.onmousemove = handleOnMouseMove;
        document.onmouseup = handleOnMouseUp;
        return () => {
            document.onmousemove = null;
            document.onmouseup = null;
        };
    }, []);
    useEffect(() => {
        columnsWatch.current = columns;
    }, [columns]);
    useEffect(() => {
        setTransportCheckedStorageItems(transportCheckedItemsAll);
    }, [transportCheckedItemsAll]);
    useEffect(() => {
        setTransportMarkedCheckedStorageItems(transportMarkedCheckedItems);
    }, [transportMarkedCheckedItems]);
    useEffect(() => {
        setTransportProcessingCheckedStorageItems(transportProcessingCheckedItems);
    }, [transportProcessingCheckedItems]);
    useEffect(() => {
        setTransportSortCheckedStorageItems(transportSortSelectedItem);
    }, [transportSortSelectedItem]);
    useEffect(() => {
        switch (transportFilterCheckedType) {
            case 'filter': {
                const sortItemsId = new Set(sortItems.map((item) => item.id));
                const checkedItems = new Set(transportMarkedCheckedItems);
                const newCheckedItems = Array.from(sortItemsId).filter((id) => !checkedItems.has(id));
                const deleteMarkedItems = Array.from(checkedItems).filter((id) => !sortItemsId.has(id));
                const newMarkedItems = transportMarkedCheckedItems.filter((item) => deleteMarkedItems.indexOf(item) === -1);
                const checkedSame = newCheckedItems.length === transportProcessingCheckedItems.length &&
                    newCheckedItems.every((id) => transportProcessingCheckedItems.indexOf(id) !== -1);
                const markedSame = newMarkedItems.length === transportMarkedCheckedItems.length &&
                    newMarkedItems.every((id, i) => id === transportMarkedCheckedItems[i]);
                if (checkedSame && markedSame) {
                    break;
                }
                batch(() => {
                    dispatch(setTransportCheckedItem(newCheckedItems));
                    dispatch(setTransportMarkedCheckedItem(newMarkedItems));
                });
                break;
            }
            case 'all':
                break;
        }
    }, [sortItems, transportFilterCheckedType]);
    useEffect(() => {
        if (transportSelectedItem && listRef.current && searchItems.length > 0) {
            const selectedIndex = searchItems.findIndex((item) => item.id === transportSelectedItem.id);
            if (selectedIndex >= 0) {
                const el = document.querySelector(`[data-id="${transportSelectedItem.id}"]`);
                if (!el) {
                    setTimeout(() => {
                        var _a;
                        (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(selectedIndex, 'center');
                    }, 100);
                }
            }
        }
    }, [transportSelectedItem === null || transportSelectedItem === void 0 ? void 0 : transportSelectedItem.id, transportSearchValue, transportSortSelectedItem]);
    return (React.createElement(Box, { component: 'div', sx: {
            width: '100%',
            height: '100%',
            '*:focus': {
                outline: 'none',
            },
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            '.simplebar-container': {
                maxHeight: 'none',
                '.simplebar-horizontal': {
                    right: '0px',
                },
                '.simplebar-vertical': {
                    top: '30px',
                    bottom: '0px',
                },
            },
        } },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(MapFilterTransportListContext.Provider, { value: {
                    items: searchItems,
                    width,
                    height,
                    columns,
                    columnsRefs: columnsRefs.current,
                    checkedItems: transportCheckedItems,
                    searchValue: transportSearchValue,
                    columnCheckedItems: transportColumnCheckedItems,
                    sortSelectedItem: transportSortSelectedItem,
                    onSortClick: handleSortClick,
                    onCheckboxClick: handleCheckboxHeadClick,
                    onClickResizeColumn: handleResizeColumn,
                    onColumnRef: handleColumnRef,
                } },
                React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => {
                    var _a, _b;
                    return (React.createElement(FixedSizeList, { ref: listRef, height: height, innerElementType: mapFilterTransportInnerElementType, itemCount: searchItems.length, itemSize: 24, stickyIndices: [0], overscanCount: 10, innerRef: contentNodeRef, outerRef: scrollableNodeRef, itemData: {
                            items: searchItems,
                            itemWidth: (_b = (_a = scrollableNodeRef === null || scrollableNodeRef === void 0 ? void 0 : scrollableNodeRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) !== null && _b !== void 0 ? _b : width,
                            columns,
                            datetimeInterval,
                            selectedItem: transportSelectedItem,
                            checkedItems: transportCheckedItems,
                            onClick: handleItemClick,
                            onDoubleClick: handleItemDoubleClick,
                            onCheckboxClick: handleCheckboxClick,
                            onColumnRef: handleColumnRef,
                        } }, MapFilterTransportListItem));
                })))))));
};
const mapFilterTransportInnerElementType = forwardRef((_a, ref) => {
    var { children, style } = _a, rest = __rest(_a, ["children", "style"]);
    return (React.createElement(MapFilterTransportListContext.Consumer, null, (context) => {
        if (!context) {
            return null;
        }
        const { items, checkedItems, searchValue, onSortClick, onClickResizeColumn, sortSelectedItem, onCheckboxClick, columns, onColumnRef } = context;
        const checked = items.every((item) => checkedItems.indexOf(item.id) !== -1);
        const indeterminate = items.some((item) => checkedItems.indexOf(item.id) !== -1);
        return (React.createElement(List, Object.assign({ ref: ref, style: Object.assign(Object.assign({}, style), { minHeight: '100%' }) }, rest),
            React.createElement(ListItem, { disablePadding: true, sx: (theme) => ({
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: style === null || style === void 0 ? void 0 : style.height,
                    minHeight: '100%',
                    zIndex: '2',
                    pointerEvents: 'none',
                    padding: theme.spacing(0),
                    '.MuiListItemText-root': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        height: '100%',
                        position: 'relative',
                        flex: 'none',
                        '&:before': {
                            content: '""',
                            position: 'absolute',
                            top: '0',
                            right: '0',
                            height: '100%',
                            bgcolor: theme.palette.divider,
                            width: '1px',
                            zIndex: '1',
                            pointerEvents: 'none',
                        },
                        '&:last-of-type': {
                            flex: '1',
                            '&:before': {
                                display: 'none',
                            },
                        },
                    },
                }) }, columns.map((column) => (React.createElement(Protect, { key: column.name, permissions: column.permissions || [], renderPermitted: () => (React.createElement(ListItemText, { style: {
                        minWidth: column.width ? column.width : column.minWidth,
                    } })), renderForbidden: () => React.createElement(React.Fragment, null) })))),
            React.createElement(ListItem, { disablePadding: true, sx: (theme) => ({
                    position: 'sticky',
                    top: '0',
                    width: '100%',
                    display: 'flex',
                    zIndex: '2',
                    '& > .MuiListItemButton-root': {
                        '&:first-of-type': {
                            '.MuiListItemText-root': {
                                paddingLeft: '31px',
                            },
                        },
                    },
                    '& > .MuiBox-root': {
                        '&:last-of-type': {
                            flex: '1',
                            '.MuiListItemText-root': {
                                paddingRight: theme.spacing(2),
                            },
                        },
                    },
                    '.MuiListItemButton-root': {
                        display: 'flex',
                        flex: 'none',
                        height: '30px',
                        padding: theme.spacing(0),
                        position: 'relative',
                        bgcolor: 'background.default',
                        borderColor: theme.palette.divider,
                        '.MuiTouchRipple-rippleVisible': {
                            color: 'inherit',
                        },
                        '.MuiListItemText-root': {
                            display: 'flex',
                            cursor: 'pointer',
                            margin: theme.spacing(0),
                            padding: '6px 6px',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            svg: {
                                fontSize: '14px',
                            },
                            '.MuiTypography-root': {
                                display: 'flex',
                                '&:nth-of-type(1)': {
                                    color: 'text.secondary',
                                    marginRight: '4px',
                                },
                                '&:nth-of-type(2) svg': {
                                    fontSize: '12px',
                                    transition: 'all 300ms',
                                    transform: 'rotateZ(0deg)',
                                },
                            },
                            '.MuiCheckbox-root': Object.assign({ padding: theme.spacing(0), marginLeft: '-2px', svg: {
                                    fontSize: '18px',
                                } }, (searchValue.length !== 0 &&
                                items.length === 0 && {
                                display: 'none',
                            })),
                        },
                    },
                }) },
                columns.slice(0, 1).map((column) => (React.createElement(ListItemButton, { key: column.name, disableTouchRipple: true, style: {
                        minWidth: column.width ? column.width : column.minWidth,
                    } },
                    React.createElement(ListItemText, { disableTypography: true },
                        React.createElement(Checkbox, { size: 'small', color: 'primary', checked: checked, indeterminate: !checked && indeterminate, onClick: onCheckboxClick, disableRipple: true }))))),
                columns.slice(1).map((column) => (React.createElement(Protect, { key: column.name, permissions: column.permissions || [], renderPermitted: () => (React.createElement(Box, { component: 'div', sx: {
                            display: 'flex',
                            position: 'relative',
                            minWidth: column.width ? column.width : column.minWidth,
                        } },
                        React.createElement(ListItemButton, { onClick: () => onSortClick(column), disableTouchRipple: !column.order, sx: (theme) => ({
                                flex: '1 1 auto !important',
                                '.MuiTypography-root': {
                                    width: 'auto',
                                    '&:nth-of-type(2)': Object.assign({ opacity: '0.2', transform: 'rotateZ(0)', transition: 'transform ' + theme.transitions.duration.shortest + 'ms ' + theme.transitions.easing.easeInOut + ' 0ms' }, (sortSelectedItem.name === column.name && Object.assign({ opacity: '1' }, (sortSelectedItem.order === 'DESC' && {
                                        transform: 'rotateZ(180deg)',
                                    })))),
                                },
                            }) },
                            React.createElement(ListItemText, { disableTypography: true },
                                React.createElement(Typography, null, column.icon ? React.createElement(MapTransportIcon, { name: column.icon }) : column.label),
                                React.createElement(Typography, null, column.order && React.createElement(ArrowUpward, { fontSize: 'small' })))),
                        React.createElement(Box, { component: 'div', ref: (el) => onColumnRef(column, el), onMouseDown: (e) => onClickResizeColumn(column, e), sx: (theme) => ({
                                minWidth: '4px',
                                minHeight: '30px',
                                cursor: 'col-resize',
                                backgroundColor: theme.palette.background.default,
                                '&:hover, &:active': {
                                    backgroundColor: alpha(theme.palette.text.secondary, 0.12),
                                },
                            }) }))), renderForbidden: () => React.createElement(React.Fragment, null) })))),
            children));
    }));
});
mapFilterTransportInnerElementType.displayName = 'MapFilterTransportInnerElementType';
const MapFilterTransportListItem = ({ data, index, style }) => {
    const { items, selectedItem, onClick, datetimeInterval, onDoubleClick, onCheckboxClick, checkedItems, columns } = data;
    const item = items[index];
    const groupTypeKey = item.group_type == null ? 'null' : String(item.group_type);
    return (React.createElement(ListItem, { key: index, style: style, disablePadding: true, "data-id": item.id, selected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === item.id, onClick: () => onClick(item), onDoubleClick: () => onDoubleClick(item), sx: (theme) => (Object.assign({ width: '100%', marginTop: '30px', userSelect: 'none', borderRadius: '0', '&:hover': {
                '.MuiListItemText-root': {
                    cursor: 'pointer',
                },
            }, '&.Mui-selected': {
                '.MuiListItemText-root': {
                    bgcolor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                },
                '.MuiCheckbox-root': {
                    color: theme.palette.primary.contrastText,
                    '&.Mui-checked': {
                        color: theme.palette.primary.contrastText,
                    },
                },
            }, '.MuiListItemText-root': {
                display: 'flex',
                flex: 'none',
                height: '100%',
                margin: theme.spacing(0),
                padding: theme.spacing(0.5, 1),
                alignItems: 'center',
                overflow: 'hidden',
                '&:first-of-type': {
                    paddingLeft: theme.spacing(2),
                    gap: '3px',
                    svg: {
                        fontSize: '16px',
                    },
                },
                '&:last-of-type': {
                    flex: '1',
                    paddingRight: theme.spacing(2),
                },
                '.MuiTypography-root': {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                },
                '.MuiCheckbox-root': {
                    padding: theme.spacing(0),
                    marginLeft: '-2px',
                    svg: {
                        fontSize: '18px',
                    },
                },
            } }, ((items.length - (items.length - 1 - index)) % 2 === 0 && {
            '& .MuiListItemText-root': {
                bgcolor: 'background.default',
            },
        }))) },
        React.createElement(ListItemText, { disableTypography: true, style: { minWidth: '38px' } },
            {
                circle: React.createElement(TransportCircleIcon, { color: item.color }),
                triangle: React.createElement(TransportTriangleIcon, { color: item.color }),
                square: React.createElement(TransportSquareIcon, { color: item.color }),
                null: React.createElement(TransportCircleIcon, { sx: { opacity: 0 } }),
            }[groupTypeKey],
            React.createElement(Checkbox, { size: 'small', color: 'primary', checked: checkedItems.indexOf(item.id) !== -1, onClick: onCheckboxClick(item), disableRipple: true })),
        columns.map((column) => {
            var _a, _b;
            const width = column.width ? column.width : column.minWidth;
            const condition = (_b = (_a = item.conditions) === null || _a === void 0 ? void 0 : _a[item.conditions.length - 1]) === null || _b === void 0 ? void 0 : _b.data;
            const deviceType = config.transportDeviceTypes[item.device_type];
            switch (column.name) {
                case 'name':
                    return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width, minWidth: width } },
                        React.createElement(Typography, null, item.name)));
                case 'number':
                    return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width, minWidth: width } },
                        React.createElement(Typography, null, item.number)));
                case 'condition':
                    return (React.createElement(Protect, { key: column.name, permissions: column.permissions || [], renderPermitted: () => (React.createElement(ListItemText, { key: column.name, disableTypography: true, sx: (theme) => ({
                                width,
                                minWidth: width,
                                div: {
                                    display: 'flex',
                                    marginRight: '2px',
                                    svg: {
                                        fontSize: '18px',
                                    },
                                },
                                'div:last-of-type': {
                                    marginRight: theme.spacing(0),
                                },
                            }) },
                            React.createElement(MapTransportConditionIconsList, { history: false, zoom: false, datetime: datetimeInterval, data: item, conditions: item.conditions }))), renderForbidden: () => React.createElement(React.Fragment, null) }));
                case 'geofence':
                    return (React.createElement(Protect, { key: column.name, permissions: column.permissions || [], renderPermitted: () => (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width, minWidth: width } },
                            React.createElement(Typography, null, condition && condition.geofence_id !== config.conditions.geofence_id.default ? condition.geofence_name : ''))), renderForbidden: () => React.createElement(React.Fragment, null) }));
                case 'total_mileage_avg':
                    return (React.createElement(Protect, { key: column.name, permissions: column.permissions || [], renderPermitted: () => (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width, minWidth: width } }, deviceType === 'galileosky' ? (React.createElement(Typography, null, (condition === null || condition === void 0 ? void 0 : condition.total_mileage_avg) != null
                            ? Math.round(Number(condition.total_mileage_avg) / 1000).toLocaleString('ru-RU')
                            : '')) : (React.createElement(Typography, null)))), renderForbidden: () => React.createElement(React.Fragment, null) }));
                case 'parking_time':
                    return (React.createElement(Protect, { key: column.name, permissions: column.permissions || [], renderPermitted: () => (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width, minWidth: width } }, deviceType === 'galileosky' ? (React.createElement(Typography, null, condition && condition.parking_time !== config.conditions.parking_time.default
                            ? Math.round(Number(condition.parking_time) / 60)
                            : '')) : (React.createElement(Typography, null)))), renderForbidden: () => React.createElement(React.Fragment, null) }));
                case 'sensor_count':
                    return (React.createElement(Protect, { key: column.name, permissions: column.permissions || [], renderPermitted: () => (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width, minWidth: width } }, deviceType === 'galileosky' ? (React.createElement(Typography, null, condition && condition.sensor_count !== config.conditions.sensor_count.default ? condition.sensor_count : '')) : (React.createElement(Typography, null)))), renderForbidden: () => React.createElement(React.Fragment, null) }));
                case 'signal_off':
                    return (React.createElement(Protect, { key: column.name, permissions: column.permissions || [], renderPermitted: () => (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width, minWidth: width } }, deviceType === 'galileosky' || deviceType === 'onlyWialon' ? (React.createElement(Typography, null, item.signal_off != null && item.signal_off > config.signalOffTimeout[0].interval[1]
                            ? Math.round(item.signal_off / 1000 / 60)
                            : '')) : (React.createElement(Typography, null)))), renderForbidden: () => React.createElement(React.Fragment, null) }));
                case 'guard_status_sum':
                    return (React.createElement(Protect, { key: column.name, permissions: column.permissions || [], renderPermitted: () => (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width, minWidth: width } }, deviceType === 'galileosky' ? (React.createElement(Typography, null, condition
                            ? config.numberOfTank
                                .map((number) => condition[`dut${number}`])
                                .filter((number) => number !== config.conditions.dut.default)
                                .reduce((a, b) => a + b, 0)
                            : '')) : (React.createElement(Typography, null)))), renderForbidden: () => React.createElement(React.Fragment, null) }));
                case 'last_activity_date':
                    return (React.createElement(Protect, { key: column.name, permissions: column.permissions || [], renderPermitted: () => (React.createElement(ListItemText, { disableTypography: true, style: { width, minWidth: width } },
                            React.createElement(Typography, null, item.last_activity_date
                                ? Math.max(Math.round(moment(datetimeInterval).diff(moment(item.last_activity_date)) / 1000 / 60), 0)
                                : ''))), renderForbidden: () => React.createElement(React.Fragment, null) }));
                default:
                    return null;
            }
        })));
};
export default MapFilterTransportList;
